import { React } from "react";
import matchStyles from "../styles/Match.styles";

const TeamSet = ({ set }) => {
	const classes = matchStyles();

	const { score, tiebreak } = set;
	return (
		<>
			{score !== null ? score : "-"}
			<span className={classes.tiebreak}>{tiebreak}</span>
		</>
	);
};

export default TeamSet;
